export enum ChartType {
  BarChart = 1,
  LineChart = 2
}
